import Glide from "@glidejs/glide";

const testimonialCardSliderHandler = () => {
	const testimonialSliders = document.querySelectorAll(
		".testimonial-card-row__glide",
	);

	testimonialSliders.forEach((slider, i) => {

		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			const autoplayValue = slider.getAttribute("data-autoplay") === "true" ? 3000 : false;
			const perViewDesktopValue = slider.getAttribute("data-perviewdesktop");
            const perViewTabletValue = slider.getAttribute("data-perviewtablet");
            const perViewMobileValue = slider.getAttribute("data-perviewmobile");
            const gapValue = slider.getAttribute("data-gap");
            
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: perViewDesktopValue,
				gap: gapValue,
				autoplay: autoplayValue,
				breakpoints: {
					1024: {
                        perView: perViewTabletValue,
					},
					641: {
						perView: perViewMobileValue,
					},
				},
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});
};

if (document.readyState !== "loading") {
	testimonialCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", testimonialCardSliderHandler);
}
